import * as constants from './constants';

export function searchStart(searchText) {
  return {
    type: constants.SEARCH_START,
    searchText,
  };
}

export function searchChunkSuccess(results, totalCount) {
  return {
    type: constants.SEARCH_CHUNK_SUCCESS,
    results,
    totalCount,
  };
}

export function searchChunkError(error) {
  return {
    type: constants.SEARCH_CHUNK_ERROR,
    error,
  };
}

export function searchClear() {
  return {
    type: constants.SEARCH_CLEAR,
  };
}

export function toggleChapter(activityId) {
  return {
    type: constants.TOGGLE_CHAPTER,
    activityId,
  };
}

export function suggestStart(searchText) {
  return {
    type: constants.SUGGEST_START,
    searchText,
  };
}

export function suggestSuccess(suggestions, searchText) {
  return {
    type: constants.SUGGEST_SUCCESS,
    suggestions,
    searchText,
  };
}

export function suggestError(error) {
  return {
    type: constants.SUGGEST_ERROR,
    error,
  };
}

export function setShowSuggestions(show) {
  return {
    type: constants.SET_SHOW_SUGGESTIONS,
    show,
  };
}

export function loadHistory(entries, rootActivityId) {
  return {
    type: constants.LOAD_HISTORY,
    entries,
    rootActivityId,
  };
}

export function addHistoryEntry(entry) {
  return {
    type: constants.ADD_HISTORY_ENTRY,
    entry,
  };
}

export function removeHistoryEntry(text) {
  return {
    type: constants.REMOVE_HISTORY_ENTRY,
    text,
  };
}

export function clearHistory() {
  return {
    type: constants.CLEAR_HISTORY,
  };
}

export function resetSearchStore() {
  return {
    type: constants.RESET_SEARCH_STORE,
  };
}

export function indexingStart() {
  return {
    type: constants.INDEXING_START,
  };
}

export function indexingDone() {
  return {
    type: constants.INDEXING_DONE,
  };
}

export function indexingError() {
  return {
    type: constants.INDEXING_ERROR,
  };
}
